function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M14 24H2a2 2 0 01-2-2V2C0 .9.9 0 2 0h12c1.1 0 2 .9 2 2v5a1 1 0 01-1 .97A1 1 0 0114 7V2H2v20h12v-5a1 1 0 011-1 1 1 0 011 1v5a2 2 0 01-2 2z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.3 15.3l2.29-2.3H7a1 1 0 01-1-1 1 1 0 011-1h13.59l-2.3-2.3a1 1 0 011.42-1.4l4 4a1 1 0 010 1.4l-4 4a1 1 0 11-1.42-1.4z"
});

var SvgIconLogout = function SvgIconLogout(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.41
  }, props), _ref, _ref2);
};

export default SvgIconLogout;